import React from 'react';
import { useTrackData } from 'src/client/hooks/useTrackData';
import { PageContent } from 'src/shared/types/cms';
import StaticPageWrapper from './static-page-wrapper';
import { useCustomer } from '../Header/customer/redux/hooks';

interface StaticPageProps {
    cmsContent?: PageContent;
}

export const CmsPage: React.FC<StaticPageProps> = ({ cmsContent }) => {
    const isGuest = useCustomer();

    useTrackData();

    return <StaticPageWrapper defaultCmsData={cmsContent?.cmsData} isGuest={isGuest} />;
};

export default CmsPage;
